import React from "react"
import {useEffect} from "react"
import {useComputed, useSignal} from "@preact/signals-react"
import {Grid} from "@mui/material"
import { LoadingIconSeeker } from "@ui-seeker/core"
import { AppFilterPanel, AppPageTabs, AppResultsSkeleton } from "@components"
import {USER_SETTINGS_TABS_ID} from "./@constants"
import {useUserSettingsContent} from "./@hooks"
import UserSettingTierTab from "./TierTab"
import UserSettingOfficesGroupTab from "./OfficesGroupTab"
import UserSettingsWebsitesTab from "./WebsitesTab"
import UserSettingsItemsTab from "./ItemsTab"
import UserSettingsSitesGroupTab from "./SitesTab"
import UserSettingWebSupplierGroupTab from "./WebSupplierGroupTab"


export default function UserSettingContent() {
	const { tabs, getAllData } = useUserSettingsContent()
	const selectedTab = useSignal(null)
	const firstLoading = useComputed(() => selectedTab.value === null)

	useEffect(() => {
		getAllData()
        selectedTab.value = USER_SETTINGS_TABS_ID.TIER
	}, [])


	return <>
		{ !firstLoading.value && <AppFilterPanel
			toggles={<AppPageTabs
				disabled={firstLoading.value}
				tabs={tabs.map(({ isLoading, ...tab }) => ({
					...tab, icon: isLoading ? <LoadingIconSeeker /> : null,
				}))}
				value={selectedTab.value}
				onChange={(_, newValue) => selectedTab.value = newValue}
				stackProps={{ sx: { mb: 0 } }}
			/>}
		/>}

		<Grid container spacing={2}>
			{firstLoading.value  && <Grid item xs={12}>
				<AppResultsSkeleton rows={10} columns={5}/>
			</Grid>}

			{ selectedTab.value === USER_SETTINGS_TABS_ID.TIER && <Grid item xs={12}>
				<UserSettingTierTab />
			</Grid> }

			{ selectedTab.value === USER_SETTINGS_TABS_ID.OFFICE_GROUP && <Grid item xs={12}>
				<UserSettingOfficesGroupTab />
			</Grid> }

	        { selectedTab.value === USER_SETTINGS_TABS_ID.SITE_GROUP && <Grid item xs={12}>
	            <UserSettingsSitesGroupTab />
	        </Grid> }

			{ selectedTab.value === USER_SETTINGS_TABS_ID.WEB_SUPPLIER_GROUP && <Grid item xs={12}>
				<UserSettingWebSupplierGroupTab />
			</Grid> }

			{ selectedTab.value === USER_SETTINGS_TABS_ID.COLORS_WEBSITE && <Grid item xs={12}>
				<UserSettingsWebsitesTab />
			</Grid> }

			{ selectedTab.value === USER_SETTINGS_TABS_ID.COLORS_ITEM && <Grid item xs={12}>
				<UserSettingsItemsTab />
			</Grid> }
		</Grid>
	</>
}
